export default __webpack_public_path__ + "static/media/Info247_logo_500x200.21fb65fe.png";